//
//
//
//

export default {
  name: 'cmHeader',
  data () {
    return {
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/cmHeader.vue